import { render, staticRenderFns } from "./Verinsumo.vue?vue&type=template&id=b23c4152"
import script from "./Verinsumo.vue?vue&type=script&lang=js"
export * from "./Verinsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports